var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Asynchronously loads the component for ProfilePreferencePage
 *
 */
import { lazy, Suspense } from 'react';
import PageLoader from '@project/components/Loaders/PageLoader';
var ProfilePreferencePage = lazy(function () { return import(/* webpackChunkName: "ProfilePreferencePage" */ './index'); });
export default function ProfilePreferencePageLoader(props) {
    return (_jsx(Suspense, __assign({ fallback: _jsx(PageLoader, {}) }, { children: _jsx(ProfilePreferencePage, __assign({}, props)) })));
}
var ProfilePreferenceChangePasswordFunc = lazy(function () {
    return import(
    /* webpackChunkName: "ProfilePreferenceChangePassword" */ './changePassword');
});
export var ProfilePreferenceChangePassword = function (props) {
    return (_jsx(Suspense, __assign({ fallback: _jsx(PageLoader, {}) }, { children: _jsx(ProfilePreferenceChangePasswordFunc, __assign({}, props)) })));
};
